export default {  
  data: () => ({
    viewedVideos: []
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  mounted() {
    this.viewedVideos = this.user.viewedVideos;
  },
  methods: {
    async setVideoViewed(idVideo) {
      await this.$store.dispatch("getCourseVideosSetViewed", {
        idUser: this.user.id,
        viewedVideos: this.viewedVideos
      });      
      if (this.updateDoNow){
        this.updateDoNow();
      }
    }
  }, 
};
